import { useField } from "formik";
import { useTranslation } from "react-i18next";

/**
 * Added to fix type error
 * @returns {[{ error: boolean }]} */
function useMuiField(name, props = {}) {
  const { t } = useTranslation();
  const [field, meta, helpers] = useField(name);

  const muiFieldProps = {
    name,
    onChange: (event) => helpers.setValue(event.target.value),
    value: field.value,
    onBlur: helpers.setTouched,
    error: !!Boolean(meta.touched && meta.error),
    helperText: meta.touched && meta.error ? t(meta.error) : null,
  };

  return [muiFieldProps, meta, helpers];
}
export default useMuiField;
